import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Blog API
export const blogAPI = {
  // Get all blog posts with optional filters
  getPosts: async (category = null, search = null) => {
    try {
      const params = {};
      if (category) params.category = category;
      if (search) params.search = search;
      
      const response = await axios.get(`${API}/blog`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  // Get single blog post by slug
  getPost: async (slug) => {
    try {
      const response = await axios.get(`${API}/blog/${slug}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blog post:', error);
      throw error;
    }
  },

  // Get all categories
  getCategories: async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      return response.data.categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  },

  // Create new blog post (admin)
  createPost: async (postData) => {
    try {
      const response = await axios.post(`${API}/blog`, postData);
      return response.data;
    } catch (error) {
      console.error('Error creating blog post:', error);
      throw error;
    }
  },

  // Update blog post (admin)
  updatePost: async (postId, postData) => {
    try {
      const response = await axios.put(`${API}/blog/${postId}`, postData);
      return response.data;
    } catch (error) {
      console.error('Error updating blog post:', error);
      throw error;
    }
  },

  // Delete blog post (admin)
  deletePost: async (postId) => {
    try {
      const response = await axios.delete(`${API}/blog/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting blog post:', error);
      throw error;
    }
  }
};

// Contact API
export const contactAPI = {
  // Submit contact form
  submit: async (contactData) => {
    try {
      const response = await axios.post(`${API}/contact`, contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  },

  // Get all contact submissions (admin)
  getSubmissions: async () => {
    try {
      const response = await axios.get(`${API}/contact`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact submissions:', error);
      throw error;
    }
  }
};

// Newsletter API
export const newsletterAPI = {
  // Subscribe to newsletter
  subscribe: async (email) => {
    try {
      const response = await axios.post(`${API}/newsletter`, { email });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    }
  },

  // Get all subscribers (admin)
  getSubscribers: async () => {
    try {
      const response = await axios.get(`${API}/newsletter`);
      return response.data;
    } catch (error) {
      console.error('Error fetching newsletter subscribers:', error);
      throw error;
    }
  }
};
